"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonTests = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const UserController_1 = __importDefault(require("../../api/UserController"));
const Formatters_1 = require("../../common/Formatters");
const RecordTestResult_1 = __importDefault(require("../actions/RecordTestResult"));
const hui_1 = require("@mit/hui");
const executeSortDesc = (a, b) => {
    const fieldName = 'date';
    let dateTimeA = (0, Formatters_1.toDate)(a[fieldName]);
    let dateTimeB = (0, Formatters_1.toDate)(b[fieldName]);
    return dateTimeB.diff(dateTimeA);
};
const PersonTestsComponent = ({ searchUser, mitId, roles }) => {
    const [personTests, setPersonTests] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [currentUser, setCurrentUser] = (0, react_1.useState)({
        name: '',
        kerberosId: '',
    });
    const [deleting, setDeleting] = React.useState(false);
    const [showWarning, setShowWarning] = React.useState(false);
    const [notification, setNotification] = React.useState(null);
    const [itemToRemove, setItemToRemove] = React.useState(null);
    (0, react_1.useEffect)(() => {
        if (mitId || searchUser && searchUser.person) {
            reloadPersonTests();
            getUserDetails(mitId);
        }
    }, [searchUser.person, mitId]);
    const reloadPersonTests = () => {
        setIsLoading(true);
        MedicalApi_1.default.fetchTestResults(mitId ? mitId : searchUser.person.mitId).then((resp) => {
            setPersonTests(resp.items ? resp.items.sort(executeSortDesc) : []);
            setIsLoading(false);
        });
    };
    const removePendingTest = () => __awaiter(void 0, void 0, void 0, function* () {
        setDeleting(true);
        yield MedicalApi_1.default.cancelPendingTests(mitId, itemToRemove.accession_number)
            .then((res) => {
            setShowWarning(false);
            setNotification(null);
            reloadPersonTests();
        }).catch((error) => {
            setNotification({
                text: error.message
            });
        });
        setDeleting(false);
    });
    const closeModal = () => {
        setShowWarning(false);
        setItemToRemove(null);
        setNotification(null);
        setDeleting(false);
    };
    const getUserDetails = (mitId) => __awaiter(void 0, void 0, void 0, function* () {
        yield UserController_1.default.fetchProfile(mitId).then((user) => {
            setCurrentUser({
                name: user.person.displayName,
                kerberosId: user.person.kerberosId
            });
        });
    });
    const columns = [
        {
            id: "date",
            name: "Date",
            sortable: true,
            formatter: (item) => { return (0, Formatters_1.displayDateTimeLong)(item.date); },
            options: {
                demandPopin: true,
                minWidth: 500,
                popinText: "Date"
            },
            filterable: false
        },
        {
            id: "accession_number",
            name: "Accession Number",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 500,
                popinText: "Accession Number"
            },
            filterable: false
        },
        {
            id: "result",
            name: "Result",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 500,
                popinText: "Result"
            },
            filterable: false
        },
    ];
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("h4", Object.assign({ className: "covid-19-tests profile-table-headers" }, { children: ["Medical Checkins", (roles === null || roles === void 0 ? void 0 : roles.roles.includes('medical')) &&
                        (0, jsx_runtime_1.jsx)(RecordTestResult_1.default, { callbackFn: reloadPersonTests, actionText: 'Add Test Result', person: currentUser })] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'person-detail-container' }, { children: [(0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, actionButtons: [
                            {
                                icon: 'trash',
                                onClick: (item) => { setItemToRemove(item); setShowWarning(true); },
                                padded: false,
                                shouldDisplay: (item) => { return item.result === "Pending"; },
                                state: 0,
                                text: '',
                                type: 64
                            },
                        ], maxRows: 1000, items: personTests, isLoading: isLoading, sortStateOptions: {
                            enabled: true,
                            key: 'covid-medical-person-tests'
                        } }), (0, jsx_runtime_1.jsx)(hui_1.TemplateModal, { name: "", show: showWarning, onClose: () => closeModal(), noExternalClose: true, bodyAlignment: hui_1.TemplateModalAlignment.Center, header: (0, jsx_runtime_1.jsx)("h2", { children: "Cancelling Pending Medical Test" }), body: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", Object.assign({ className: "mt-3" }, { children: ["Are you sure you want to cancel ", itemToRemove ? itemToRemove.accession_number : "", " ? "] })), notification &&
                                    (0, jsx_runtime_1.jsx)(hui_1.Alert, { text: notification.text, type: "error", icon: 'exclamation-triangle' })] }), footer: (0, jsx_runtime_1.jsx)(hui_1.Button, { state: deleting ? hui_1.ButtonState.Disabled : hui_1.ButtonState.Enabled, isBusy: deleting, text: "Delete", onClick: () => removePendingTest() }) })] }))] });
};
exports.PersonTests = (0, mobx_react_1.inject)('searchUser', 'roles')((0, mobx_react_1.observer)(PersonTestsComponent));
